var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_31425)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3692 31.0237C34.9747 40.4466 27.2139 47.9655 17.6941 47.9655C7.9219 47.9655 1.24208e-05 39.7772 1.24208e-05 30.2714C1.24208e-05 29.0008 -0.0227641 26.4615 1.88237 22.1772C3.02251 19.6133 3.73761 18.0026 4.14119 16.5302C4.36293 15.721 4.79418 14.4353 6.02354 16.5302C6.74844 17.7654 6.77648 19.5419 6.77648 19.5419C6.77648 19.5419 9.47352 17.4723 11.2941 13.5184C13.9631 7.72209 11.8336 4.25724 11.1059 1.84783C10.854 1.01432 10.6959 -0.483653 12.4235 0.153712C14.1839 0.803312 18.8379 4.0611 21.2706 7.49489C24.7426 12.3956 25.9765 17.0949 25.9765 17.0949C25.9765 17.0949 27.0882 15.7151 27.4824 14.2714C27.9275 12.6411 27.9341 11.0264 29.3645 12.7657C30.7249 14.4197 32.7452 17.528 33.8824 20.4831C35.9471 25.8495 35.3692 31.0237 35.3692 31.0237Z",
    fill: "#FC9502"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_31425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.4,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.6153bc13236b013b17c6e0a0fd5257d6.svg";
export { ForwardRef as ReactComponent };